import React, { Component } from 'react';
import styled from '@emotion/styled';
import DangerButton from '../../buttons/DangerButton';
import TextButton from '../../buttons/TextButton';

const ModalBody = styled.div`
  background: #fff;
  padding: 10px 2rem;
  display: flex;
  flex-direction: column;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;

  a {
    margin-right: 1.5rem;
  }
`;

interface Props {
  closeFn: () => void;
  projectId: number;
  apiUrl?: string;
}

interface State {
  error: boolean;
}

export class DeleteModal extends Component<Props> {
  state = {
    error: false,
  } as State;

  render() {
    const deleteProject = async () => {
      const url = this.props.apiUrl
        ? `${this.props.apiUrl}/api/projects/${this.props.projectId}`
        : `/api/projects/${this.props.projectId}`;

      const response = await fetch(url, {
        credentials: 'same-origin',
        method: 'DELETE',
      });
      if (response.status === 200) {
        window.location.href = '/projects';
      } else {
        this.setState({ error: true });
      }
    };

    const errorBody = (
      <>
        <p>Something has gone wrong. Please try again.</p>
        <p>
          Contact <a href="https://support.liveoptics.com/">support</a> if the issue persists.
        </p>
      </>
    );
    const body = (
      <>
        <p>Are you sure you want to delete this project?</p>
        <ButtonGroup>
          <TextButton clickFn={this.props.closeFn}>Cancel</TextButton>
          <DangerButton testId="delete-modal-confirm" clickFn={deleteProject}>
            Delete
          </DangerButton>
        </ButtonGroup>
      </>
    );

    return this.state.error ? (
      <ModalBody data-testid="delete-modal-error">{errorBody}</ModalBody>
    ) : (
      <ModalBody data-testid="delete-modal-info">{body}</ModalBody>
    );
  }
}
